import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputFormFieldComponent } from '../fields/input-form-field/input-form-field.component';
import { TranslateModule } from '@ngx-translate/core';
import { SelectFormFieldComponent } from '../fields/select-form-field/select-form-field.component';
import { DropdownEntryEnum, DropdownTypeEnum } from 'app/shared/enums/dropdowns.enum';
import { take } from 'rxjs';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { HelperService } from 'app/shared/services/helper.service';
import { ConfigurationSelectFormFieldComponent } from '../fields/configuration-select-form-field/configuration-select-form-field.component';
import { CaseFormModel } from 'app/case-form/case-form.model';

@Component({
  selector: 'app-customer-details-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputFormFieldComponent,
    TranslateModule,
    SelectFormFieldComponent,
    ConfigurationSelectFormFieldComponent,
  ],
  templateUrl: './customer-details-form.component.html',
  styleUrl: './customer-details-form.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class CustomerDetailsFormComponent implements OnInit {
  @Input() extended!: boolean;
  @Input() viewMode!: boolean;
  @Input() caseId: number | null = null;
  @Input() case!: CaseFormModel;

  customerNameSiteData: any = [];
  customerCountryItems: any = [];
  customerGlobalNameItems: any = [];
  smaFactoryNameItems: any = [];

  form: any;
  customerRegionData: any = [];
  errorTextCustomerContactEmail: string = '';

  customerRegionParams = {
    type: DropdownTypeEnum.CUSTOMER_REGION,
    parentId: '',
    filter: '',
    pageSize: 100
  };
  dropdownTypeEnum = DropdownTypeEnum;
  dropdownType = DropdownTypeEnum.CUSTOMER_INFORMATION;
  entry1 = DropdownEntryEnum.ENTRY_1;
  entry2 = DropdownEntryEnum.ENTRY_2;
  entry3 = DropdownEntryEnum.ENTRY_3;

  constructor(
    public mainForm: FormGroupDirective,
    private configurationService: ConfigurationService,
    private helperService: HelperService,
  ) { }

  ngOnInit(): void {
    this.createForm();
  }

  ngOnChanges() {
    if (this.case) {
      this.helperService.enableDisableDependentFieldOnSelect(this.form, this.case.customerRegion, 'customerSite');
    }
  }

  customerContactEmailValueChange(value: string) {
    this.form.controls['customerContactEmail'].setValidators(value.toLowerCase() === 'n/a' ? null : [Validators.email]);
    this.form.get('customerContactEmail').updateValueAndValidity();
    this.errorTextCustomerContactEmail = this.helperService.handleFieldsErrors(this.form.get('customerContactEmail'));
  }

  createForm() {
    this.form = this.mainForm.form;

    this.form.addControl('customerRegion', new FormControl(null, [Validators.required]));
    this.form.addControl('customerSite', new FormControl({ value: null, disabled: !this.viewMode }, [Validators.required]));
    this.form.addControl('customerContactName', new FormControl(null));
    this.form.addControl('customerContactPhone', new FormControl(null, [Validators.pattern(/^[\d\+\-\(\)\s]{1,}$/)]));
    this.form.addControl('customerContactEmail', new FormControl(null, [Validators.email]));
    this.form.addControl('customerContactRole', new FormControl(null, []));
    this.form.addControl('customerCountry', new FormControl({ value: null, disabled: true }, []));
    this.form.addControl('customerGlobalName', new FormControl({ value: null, disabled: true }, []));
    this.form.addControl('smaFactoryName', new FormControl({ value: null, disabled: true }, []));
  }

  onSelectField(data: any, field: string) {
    this.resetCustomerSiteAndCustomerCountry(field === DropdownTypeEnum.CUSTOMER_SITE);
    this.resetCustomerGlobalNameAndSmaFactoryName();
    if (field === DropdownTypeEnum.CUSTOMER_REGION) {
      this.helperService.enableDisableDependentFieldOnSelect(this.form, data, 'customerSite');
    }

    if (!data) {
      return;
    }

    let params = {
      type: this.dropdownType,
      entry1: this.form.get('customerRegion')?.value || '',
      entry2: '',
      entry3: this.form.get('customerSite')?.value || '',
    };

    if (!params.entry1) {
      return;
    }

    switch (field) {
      case DropdownTypeEnum.CUSTOMER_REGION:
        this.configurationService.getDropdownConfigurations(params, this.entry3)
          .pipe(take(1))
          .subscribe((res: any) => {
            this.customerNameSiteData = res;
          });
        break;
      case DropdownTypeEnum.CUSTOMER_SITE:
        this.getAdditionalData();
        break;
    }

  }

  getAdditionalData() {
    const params = {
      type: this.dropdownType,
      entry1: this.form.get('customerRegion')?.value || '',
      entry2: '',
      entry3: this.form.get('customerSite')?.value || '',
    };

    this.configurationService.getSingleDropdownConfigurations(params)
      .pipe(take(1))
      .subscribe((res: any) => {
        this.form.get('customerCountry')?.setValue(res ? res.entry2 : null);
        this.form.get('smaFactoryName')?.setValue(res ? res.entry4 : null);
        this.form.get('customerGlobalName')?.setValue(res ? res.entry5 : null);
      });
  }

  resetCustomerSiteAndCustomerCountry(isCustomerSite: boolean) {
    if (!isCustomerSite) {
      this.form.get('customerSite').setValue(null);
      this.customerNameSiteData = [];
    }

    this.form.get('customerCountry').setValue(null);
    this.customerCountryItems = [];
  }

  resetCustomerGlobalNameAndSmaFactoryName() {
    this.form.get('customerGlobalName').setValue(null);
    this.form.get('smaFactoryName').setValue(null);
    this.customerGlobalNameItems = [];
    this.smaFactoryNameItems = [];
  }

}
